import React, { useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  CSidebarMinimizer,
  CSidebarNavDropdown,
  CSidebarNavItem,
} from '@coreui/react';

import CIcon from '@coreui/icons-react';
import { toogleSidebar } from '../app.actions';
// sidebar nav config
const navigation = [
  {
    _tag: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
    clientVisible: false,
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Awarie',
    to: '/breakdowns/not_opened',
    icon: 'cil-drop',
    clientVisible: false,
    visibalityParam: 'areBreakdownsVisible',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Firmy',
    to: '/companies',
    icon: 'cil-briefcase',
    clientVisible: true,
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Samochody',
    to: '/cars',
    icon: 'cil-car-alt',
    clientVisible: true,
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Gwarancje',
    to: '/warranties',
    icon: 'cil-bank',
    clientVisible: true,
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Użytkownicy',
    to: '/users',
    icon: 'cil-user',
    clientVisible: true,
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Raporty',
    to: '/reports',
    icon: 'cil-chart-line',
    clientVisible: false,
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Konfiguracja',
    icon: 'cil-settings',
    clientVisible: false,
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'Marki',
        to: '/dictionary/manufacturers',
        icon: 'cil-puzzle',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Rodzaj paliwa',
        to: '/dictionary/fuels',
        icon: 'cil-puzzle',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Gwarancje',
        to: '/dictionary/warranties',
        icon: 'cil-puzzle',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Grupy klientów',
        to: '/dictionary/company-groups',
        icon: 'cil-puzzle',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Grupy Awarii',
        to: '/dictionary/breakdown-types',
        icon: 'cil-puzzle',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Logi',
        to: '/logs',
        icon: 'cil-puzzle',
      },
    ],
  },
];

const logo = require('../../../assets/images/logo_01.svg');

const Sidebar = () => {
  const dispatch = useDispatch();
  const show = useSelector((state) => state.app.sidebarShow);
  const isAdmin = useSelector((state) => state.auth.isAdmin);
  const areBreakdownsVisible = useSelector((state) => state.auth.company.areBreakdownsVisible);

  const checkVisibleParam = useCallback((itemVisibalityParam, paramName, paramValue) => (itemVisibalityParam === paramName) && paramValue, []);

  const toggleSidebar = useCallback(() => dispatch(toogleSidebar()), [dispatch]);

  const navigationItems = useMemo(() => navigation.filter((navItem) => navItem.clientVisible || isAdmin || checkVisibleParam(navItem.visibalityParam, 'areBreakdownsVisible', areBreakdownsVisible))
    .map(({ clientVisible, visibalityParam, ...navItemDOM }) => navItemDOM),
  [isAdmin, checkVisibleParam, areBreakdownsVisible]);

  return (
    <CSidebar
      show={show}
      onShowChange={toggleSidebar}
      hideOnMobileClick
    >
      <CSidebarBrand to={isAdmin ? '/' : '/cars'}>
        <CIcon
          className="c-sidebar-brand-full padding-0"
          src={logo}
          height={103}
        />
      </CSidebarBrand>
      <CSidebarNav>
        <CCreateElement
          items={navigationItems}
          components={{
            CSidebarNavDivider,
            CSidebarNavDropdown,
            CSidebarNavItem,
            CSidebarNavTitle,
          }}
        />
      </CSidebarNav>
      <CSidebarMinimizer className="c-d-md-down-none" />
    </CSidebar>
  );
};

export default React.memo(Sidebar);
